import React from 'react';
import moment from 'moment';
import _pick from 'lodash/pick';

import PromoCode from './promo-code';
import Discount from './discount';
import PropTypes from 'prop-types';

const SingleBonus = props => {
	const { partner_logo, partner_name, partner_description_ru, partner_description_en, discounts_end_at, intl } =
		props;
	const discountProps = _pick(props, ['discount_value', 'terms_ru', 'terms_en']);
	const promoCodeProps = _pick(props, ['promo_code', 'intl', 'is_link_promo_code', 'redirect_link']);
	const formattedDate = discounts_end_at ? moment(discounts_end_at).format('DD.MM.YYYY') : intl('Lifetime');

	return (
		<div className="program-item">
			<div className="program-image">
				<img src={ partner_logo }></img>
			</div>
			<div className="program-description">
				<h3 className="program-description__title font-proxima-nova-bold">{ partner_name }</h3>
				<span
					className="program-description__text font-proxima-nova-regular"
				>
					{intl.language === 'ru' ? partner_description_ru :  partner_description_en}
				</span>
			</div>
			<div className="program-promocode">
				<Discount
					{...discountProps}
					terms={intl.language === 'ru' ? discountProps.terms_ru : discountProps.terms_en}
				/>
				<div className="program-promocode__code font-proxima-nova-regular">
					<div>
						<PromoCode {...promoCodeProps}/>
						<div className="date-container">
							<span className="valid-until">
								{intl('Действует до')}:
							</span> <span className="black">{ `${formattedDate}` }</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

SingleBonus.propTypes = {
	intl: PropTypes.func,
	title: PropTypes.string,
	discount_value: PropTypes.string,
	isRefLink: PropTypes.bool,
	promo_code: PropTypes.string,
	discounts_end_at: PropTypes.string,
	discount_terms: PropTypes.array,
	partner_name: PropTypes.string,
	partner_description_ru: PropTypes.string,
	partner_description_en: PropTypes.string,
	partner_logo: PropTypes.string,
	promo: PropTypes.string,
	discounts: PropTypes.array,
	text: PropTypes.string
};

export default SingleBonus;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/discounts/components/single-bonus.js